<template>
  <div
    v-editable="blok"
    class="section"
    :class="props.blok.displayBorder ? 'section--bordered' : ''"
  >
    <component v-if="blok.displayTitle" :is="blok.size || 'h1'" :style="titleStyle" class="title">
      {{ blok.title }}
    </component>
    <div class="nested-bloks">
      <StoryblokComponent
        v-for="nestedBlok in nestedBloks"
        :key="nestedBlok._uid"
        :blok="nestedBlok"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';
import { computed } from 'vue';
import type { StoryblokSectionBlok } from '@/features/storyblok/types';

const props = defineProps<{
  blok: StoryblokSectionBlok;
}>();

const nestedBloks = computed(() => props.blok.content ?? props.blok.body ?? []);

const titleStyle = computed(() => {
  let formattedStyles = '';
  if (!props.blok.titleStyle) return formattedStyles;
  if (props.blok.titleStyle.includes('underline')) {
    formattedStyles += 'text-decoration: underline;';
  }
  if (props.blok.titleStyle.includes('bold')) {
    formattedStyles += 'font-weight: bold;';
  }
  if (props.blok.titleStyle.includes('italic')) {
    formattedStyles += 'font-style: italic;';
  }
  if (props.blok.titleStyle.includes('uppercase')) {
    formattedStyles += 'text-transform: uppercase;';
  }
  return formattedStyles;
});
</script>

<style scoped>
.section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.section--bordered {
  border: 1px solid var(--ion-color-primary);
  border-radius: var(--ion-radius-2xl);
  padding: 1rem;
}
.nested-bloks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  margin-top: 1rem;
  gap: 1rem;
}

@media (max-width: 768px) {
  .nested-bloks {
    grid-template-columns: 1fr;
  }
}
</style>
